export default {
    allow_to_make_payment_in_insurance_visits: "Сақтандыру келулерде қосымша ақы төлеуге рұқсат ету",
    insurance_companies: "Сақтандыру компаниялары",
    insurance_polis: "Сақтандыру полисі",
    limit: "Лимит",
    number: "Нөмір",
    paid_by_insurance: "Сақтандырумен төленді",
    paid_by_patient: "Пациентпен төленді",
    polis: "Полис",
    polises: "Полистер",
    use_custom_prices_for_insurance: "Сақтандыру компаниялары үшін жеке бағаларды пайдалану",
    use_only_in_insurance: "Сақтандырылғандарды ғана пайдалану",
    valid_from: "бастап жарамды",
    valid_to: "дейін жарамды",
    visit_should_have_polis_set_in_order_to_use_insurance_payment: "Келуде сақтандыру төлемін пайдалану үшін сақтандыру полисі толтырылуы тиіс",
}

